// @flow
import * as React from 'react';
import { Box, Image, Text } from 'grommet';
import ReactTooltip from 'react-tooltip';

// SOURCE: https://github.com/taysea/grommet-dropzone

type Props = {
    file: {
        name: string,
        size: number,
        type: string,
        path: string,
        preview?: string,
    },
    showPreview: boolean,
    icon?: React.Element;
}

const truncateText = (text) => {
    if (text.length > 15) {
        const truncatedText = text.substr(0, 15);
        return `${truncatedText}...`;
    }
    return text;
};

const imageFormats = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];

const FileInfo = ({ file, showPreview, icon }: Props) => (
    <Box direction="row" gap="xsmall" align="center" data-tip data-for={file.name}>
        {showPreview && (
            <Box width="xxsmall" height="xxsmall">
                {imageFormats.indexOf(file.type) !== -1 ? (
                    <Image src={file.preview} fit="cover" />
                ) : (
                    icon
                )}
            </Box>
        )}
        <Text weight="bold">{truncateText(file.name)}</Text>
        <ReactTooltip
            id={file.name}
            effect="solid"
            place="top"
            className="react-tooltip"
            delayShow={800}
        >
            <Text size="xsmall">
                {file.name}
            </Text>
        </ReactTooltip>
    </Box>
);

FileInfo.defaultProps = {
    icon: null,
};

export default FileInfo;
